import { Record } from "immutable";
import { GroupUserUploadResult } from "../../interfaces/groups/group-user-upload-result";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: GroupUserUploadResult = {
    email: undefined,
    errors: undefined,
    userId: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class GroupUserUploadResultRecord extends Record(defaultValues) implements GroupUserUploadResult {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<GroupUserUploadResult>) {
        params = params ?? Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Given a set of values for EnrollmentUser properties, create a new EnrollmentUserRecord object
     * from this instance, overwriting the properties in the values parameter with values provided.
     *
     * @param {Partial<EnrollmentUser>} values The values to overwrite on this instance.
     * @returns A EnrollmentUserRecord with values from this instance and the values parameter.
     */
    public with(values: Partial<GroupUserUploadResultRecord>): GroupUserUploadResultRecord {
        return new GroupUserUploadResultRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { GroupUserUploadResultRecord };

// #endregion Exports
